import PrivateRoomsTable from "./PrivateRoomsTable";

export default PrivateRoomsTable;
